var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiInputLabelOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography, transitions = _a.transitions;
    return ({
        root: __assign(__assign({}, typography.body1), { lineHeight: 1, textTransform: "unset", color: palette.text.secondary }),
        outlined: {
            margin: 0,
            lineHeight: 1.4,
            transform: "translate(".concat(spacing(4), "px, ").concat(spacing(4), "px) scale(1)"),
            "&$shrink": {
                transform: "translate(".concat(spacing(4), "px, ").concat(spacing(2), "px) scale(0.875)"),
            },
            //for small input
            "&$marginDense": {
                transition: [
                    transitions.create(["opacity", "transform"], {
                        duration: transitions.duration.shorter,
                    }),
                    transitions.create("visibility", { duration: 0 }),
                ].join(),
                transform: "translate(".concat(spacing(2), "px, ").concat(spacing(2), "px)"),
                "&$shrink": {
                    transform: "translate(".concat(spacing(2), "px, ").concat(spacing(2), "px)"),
                    visibility: "hidden",
                    opacity: "0",
                    transition: [
                        transitions.create(["opacity", "transform"], {
                            duration: transitions.duration.shorter,
                        }),
                        transitions.create("visibility", {
                            delay: transitions.duration.shorter,
                        }),
                    ].join(),
                },
            },
        },
        asterisk: {
            color: palette.warning.main,
            marginLeft: spacing(1),
        },
    });
};
//# sourceMappingURL=MuiInputLabel.js.map